import React, { useLayoutEffect } from 'react';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import { useScreenSize } from '../hooks/useScreenSize';
import '../styles/cjenik.css';
import backgroundImageMobile from '../assets/webp/mobile/Contact2.webp';
import backgroundImageDesktop from '../assets/webp/desktop/Contact2.webp';

const Instrukcije = () => {
  const { isDesktop } = useScreenSize();
  const backgroundImage = isDesktop ? backgroundImageDesktop : backgroundImageMobile;

  // Add CSS variable for the background image
  useLayoutEffect(() => {
    document.documentElement.style.setProperty('--hero-bg-image', `url(${backgroundImage})`);
  }, [backgroundImage]);

  return (
    <>
      <Helmet>
        <title>Instrukcije Računovodstvo | Instrukcije Ekonomija | Cijene i Predmeti - Konto Zona</title>
        <meta name="description" content="Instrukcije računovodstvo (20€/h) te ekonomija, statistika i matematika. Online termini za studente EFZG, EFRI, EFST i EFOS. PDF sažeci, materijali i fleksibilni termini." />
        <meta name="keywords" content="instrukcije, instrukcije računovodstvo, instrukcije računovodstvo cijena, instrukcije ekonomija, instrukcije ekonomija cijena, instrukcije statistika, instrukcije matematika, individualne instrukcije, grupne instrukcije, instrukcije cijena, instrukcije Zagreb, online instrukcije, instrukcije za studente, instrukcije EFZG, instrukcije EFRI, instrukcije EFST, instrukcije EFOS, instrukcije osnove računovodstva, instrukcije bilanca, instrukcije račun dobiti i gubitka, instrukcije knjigovodstvo, instrukcije gospodarska statistika, instrukcije gospodarska matematika" />
        <meta property="og:title" content="Instrukcije Računovodstvo | Instrukcije Ekonomija | Cijene - Konto Zona" />
        <meta property="og:description" content="Instrukcije računovodstvo, instrukcije ekonomija, instrukcije statistika i instrukcije matematika. Individualne (20€/h) i grupne (12€/h) instrukcije online i uživo." />
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://instrukcijekontozona.hr/instrukcije" />
        <meta property="og:image" content="https://instrukcijekontozona.hr/kontozona-logo.png" />
        <meta property="og:locale" content="hr_HR" />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="Instrukcije Računovodstvo | Instrukcije Ekonomija | Cijene - Konto Zona" />
        <meta name="twitter:description" content="Instrukcije računovodstvo, instrukcije ekonomija, instrukcije statistika i instrukcije matematika. Individualne (20€/h) i grupne (12€/h) instrukcije online i uživo." />
        <meta name="twitter:image" content="https://instrukcijekontozona.hr/kontozona-logo.png" />
        <link rel="canonical" href="https://instrukcijekontozona.hr/instrukcije" />
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "Service",
            "serviceType": "Instrukcije",
            "provider": {
              "@type": "EducationalOrganization",
              "name": "Konto Zona",
              "address": {
                "@type": "PostalAddress",
                "streetAddress": "Diljska ulica 26",
                "addressLocality": "Zagreb",
                "addressCountry": "HR"
              }
            },
            "areaServed": "Zagreb, Hrvatska",
            "hasOfferCatalog": {
              "@type": "OfferCatalog",
              "name": "Instrukcije",
              "itemListElement": [
                {
                  "@type": "Offer",
                  "itemOffered": {
                    "@type": "Service",
                    "name": "Instrukcije računovodstvo",
                    "description": "Individualne i grupne instrukcije iz računovodstva"
                  },
                  "price": "20",
                  "priceCurrency": "EUR"
                },
                {
                  "@type": "Offer",
                  "itemOffered": {
                    "@type": "Service",
                    "name": "Instrukcije ekonomija",
                    "description": "Individualne i grupne instrukcije iz ekonomije"
                  },
                  "price": "20",
                  "priceCurrency": "EUR"
                },
                {
                  "@type": "Offer",
                  "itemOffered": {
                    "@type": "Service",
                    "name": "Instrukcije statistika",
                    "description": "Individualne i grupne instrukcije iz statistike"
                  },
                  "price": "20",
                  "priceCurrency": "EUR"
                },
                {
                  "@type": "Offer",
                  "itemOffered": {
                    "@type": "Service",
                    "name": "Instrukcije matematika",
                    "description": "Individualne i grupne instrukcije iz matematike"
                  },
                  "price": "20",
                  "priceCurrency": "EUR"
                }
              ]
            }
          })}
        </script>
      </Helmet>
      {/* SEKCIJA 1: PREDMETI */}
      <section 
        className="section hero-section"
        style={{
          backgroundImage: `url(${backgroundImage})`,
          backgroundSize: 'cover',
          backgroundRepeat: 'no-repeat',
          backgroundPosition: 'center center',
          backgroundAttachment: 'scroll',
          minHeight: 'calc(100vh - var(--header-height))',
          display: 'flex',
          alignItems: 'center',
          position: 'relative',
          zIndex: 10,
          backgroundColor: 'rgba(0, 0, 0, 0.9)'
        }}
      >
        <div className="container">
          <div className="section-title">
            <h1 style={{textShadow: "2px 2px 4px rgba(0, 0, 0, 0.7)" }}>Instrukcije Računovodstvo, Ekonomija, Statistika i Matematika</h1>
            <p>Otključavamo logiku iza najzahtjevnijih ekonomskih predmeta.</p>
          </div>
          <div className="grid-3 subject-grid">
            <a href="#individualne" className="card subject-card" onClick={(e) => {
              e.preventDefault();
              document.getElementById('individualne').scrollIntoView({ 
                behavior: 'smooth', 
                block: 'start' 
              });
            }}>
              <i className="fas fa-calculator"></i>
              <h3>Računovodstvo</h3>
            </a>
            <a href="#individualne" className="card subject-card" onClick={(e) => {
              e.preventDefault();
              document.getElementById('individualne').scrollIntoView({ 
                behavior: 'smooth', 
                block: 'start' 
              });
            }}>
              <i className="fas fa-chart-line"></i>
              <h3>Osnove ekonomije</h3>
            </a>
            <a href="#individualne" className="card subject-card" onClick={(e) => {
              e.preventDefault();
              document.getElementById('individualne').scrollIntoView({ 
                behavior: 'smooth', 
                block: 'start' 
              });
            }}>
              <i className="fas fa-infinity"></i>
              <h3>Gospodarska matematika</h3>
            </a>
            <a href="#individualne" className="card subject-card" onClick={(e) => {
              e.preventDefault();
              document.getElementById('individualne').scrollIntoView({ 
                behavior: 'smooth', 
                block: 'start' 
              });
            }}>
              <i className="fas fa-percentage"></i>
              <h3>Gospodarska statistika</h3>
            </a>
            <a href="#individualne" className="card subject-card" onClick={(e) => {
              e.preventDefault();
              document.getElementById('individualne').scrollIntoView({ 
                behavior: 'smooth', 
                block: 'start' 
              });
            }}>
              <i className="fas fa-clipboard-list"></i>
              <h3>Poslovno planiranje</h3>
            </a>
            <div className="card subject-card dashed-card">
              <p>I još mnogo toga u pripremi...</p>
            </div>
          </div>
        </div>
      </section>

      {/* SEKCIJA 2: CJENIK INDIVIDUALNIH INSTRUKCIJA */}
      <section id="individualne" className="section section-alt-bg">
        <div className="container">
          <div className="section-title">
            <h2>Individualne Instrukcije</h2>
            <p>Tri paketa dizajnirana da odgovore na tvoje potrebe – od planiranog rada do hitnih intervencija!</p>
          </div>
          <div className="grid-3 pricing-table">
            {/* BLUE FIRST - CLASSIC TERMIN */}
            <div className="pricing-card blue-first">
              <div className="card-header">
                <h4><i className="fas fa-graduation-cap"></i> CLASSIC TERMIN</h4>
                <p className="price-description">Temelj za siguran napredak.</p>
              </div>
              <p className="price">20€<span> / 60 min</span></p>
              <ul className="benefits">
                <li><i className="far fa-calendar-alt"></i>Termin po redovnom rasporedu</li>
                <li><i className="far fa-file-pdf"></i>Sažetak sata u PDF-u</li>
                <li><i className="far fa-comments"></i>Standardna podrška (WA/Mail)</li>
              </ul>
              <Link to="/kontakt#form" className="btn btn-blue-first">Odaberi</Link>
            </div>
            {/* RED SECOND - EXPRESS TERMIN */}
            <div className="pricing-card red-second">
              <div className="card-header">
                <h4><i className="fas fa-bolt"></i> EXPRESS TERMIN</h4>
                <p className="price-description">Tvoj spas kad je najhitnije.</p>
              </div>
              <p className="price">25€<span> / 60 min</span></p>
              <ul className="benefits">
                <li><i className="fas fa-shipping-fast"></i>Termin danas za danas!</li>
                <li><i className="far fa-file-pdf"></i>Sažetak sata u PDF-u</li>
                <li><i className="far fa-comments"></i>Standardna podrška (WA/Mail)</li>
              </ul>
              <Link to="/kontakt#form" className="btn btn-express">Trebam odmah!</Link>
            </div>
            {/* GREEN THIRD - INSTRUKCIJE ZA SREDNJU ŠKOLU */}
            <div className="pricing-card green-third">
              <div className="card-header">
                <h4><i className="fas fa-book"></i> Srednjoškolski termin</h4>
                <p className="price-description">Priprema za sve predmete.</p>
              </div>
              <p className="price">18€<span> / 60 min</span></p>
              <ul className="benefits">
                <li><i className="far fa-calendar-alt"></i>Termin po redovnom rasporedu</li>
                <li><i className="far fa-file-pdf"></i>Sažetak sata u PDF-u</li>
                <li><i className="far fa-comments"></i>Standardna podrška (WA/Mail)</li>
              </ul>
              <Link to="/kontakt#form" className="btn btn-green-third">Odaberi</Link>
            </div>
          </div>
        </div>
      </section>
      
      {/* SEKCIJA 3: GRUPNE INSTRUKCIJE */}
      <section id="grupne" className="section">
        <div className="container">
          <div className="section-title">
            <h2>Grupne Instrukcije</h2>
            <p>Timski rad donosi pametnu uštedu i ne dopušta opuštanje – jer kad netko posustane, ekipa je tu da ga podigne!</p>
          </div>
          <div className="grid-3 pricing-table group-pricing">
            {/* Tim od 2 */}
            <div className="pricing-card blue-first">
              <div className="card-header">
                <h4><i className="fas fa-user-friends"></i> TIM OD DVOJE</h4>
                <p className="price-description">Idealan start za učenje u paru.</p>
              </div>
              <p className="price">15€<span className="price-per-person"> / 60 min po osobi</span></p>
              <p className="savings-text subtle">Puna cijena: <del>20€</del> <span className="discount-pill">-22%</span></p>
              <ul className="benefits">
                <li><i className="far fa-calendar-alt"></i>Termin po redovnom rasporedu</li>
                <li><i className="far fa-file-pdf"></i>Sažetak sata u PDF-u</li>
                <li><i className="far fa-comments"></i>Standardna podrška (WA/Mail)</li>
              </ul>
              <Link to="/kontakt#form" className="btn btn-blue-first">Okupi tim</Link>
            </div>
            {/* Tim od 3 */}
            <div className="pricing-card red-second">
              <div className="card-header">
                <h4><i className="fas fa-users"></i> TIM OD TROJE</h4>
                <p className="price-description">Najbolji omjer interakcije i cijene.</p>
              </div>
              <p className="price">13€<span className="price-per-person"> / 60 min po osobi</span></p>
              <p className="savings-text subtle">Puna cijena: <del>20€</del> <span className="discount-pill">-33%</span></p>
              <ul className="benefits">
                <li><i className="far fa-calendar-alt"></i>Termin po redovnom rasporedu</li>
                <li><i className="far fa-file-pdf"></i>Sažetak sata u PDF-u</li>
                <li><i className="far fa-comments"></i>Standardna podrška (WA/Mail)</li>
              </ul>
              <Link to="/kontakt#form" className="btn btn-express">Okupi tim</Link>
            </div>
            {/* Tim od 4 */}
            <div className="pricing-card green-third">
              <div className="card-header">
                <h4><i className="fas fa-university"></i> TIM OD ČETVERO</h4>
                <p className="price-description">Maksimalna ušteda za cijelu ekipu.</p>
              </div>
              <p className="price">11€<span className="price-per-person"> / 60 min po osobi</span></p>
              <p className="savings-text subtle">Puna cijena: <del>20€</del> <span className="discount-pill">-44%</span></p>
              <ul className="benefits">
                <li><i className="far fa-calendar-alt"></i>Termin po redovnom rasporedu</li>
                <li><i className="far fa-file-pdf"></i>Sažetak sata u PDF-u</li>
                <li><i className="far fa-comments"></i>Standardna podrška (WA/Mail)</li>
              </ul>
              <Link to="/kontakt#form" className="btn btn-green-third">Okupi tim</Link>
            </div>
          </div>
        </div>
      </section>

      {/* SEKCIJA 4: DODATNI DETALJI */}
      <section className="section section-alt-bg">
        <div className="container dual-section">
          {/* Protokol */}
          <div className="info-block">
            <h3 className="info-block-title">Naš Protokol za Suradnju</h3>
            <ul className="info-list">
              <li>
                <div className="info-icon blue-icon"><i className="fas fa-users"></i></div>
                <div>
                  <h4>Vi Formirate Tim</h4>
                  <p>Okupite 2 do 4 kolega s istim ciljem.</p>
                </div>
              </li>
              <li>
                <div className="info-icon blue-icon"><i className="fas fa-calendar-check"></i></div>
                <div>
                  <h4>Dogovaramo Detalje</h4>
                  <p>Javite nam se i zajedno pronalazimo idealan termin.</p>
                </div>
              </li>
              <li>
                <div className="info-icon blue-icon"><i className="fas fa-rocket"></i></div>
                <div>
                  <h4>Krenite s Učenjem!</h4>
                  <p>Nakon potvrde, dobivate link i vaša misija počinje.</p>
                </div>
              </li>
            </ul>
          </div>
          {/* Prednosti */}
          <div className="info-block">
            <h3 className="info-block-title">Ključne prednosti timskog rada</h3>
            <ul className="info-list">
              <li>
                <div className="info-icon green-icon"><i className="fas fa-coins"></i></div>
                <div>
                  <h4>Financijska isplativost</h4>
                  <p>Dobivate pristup premium instrukcijama uz značajnu uštedu.</p>
                </div>
              </li>
              <li>
                <div className="info-icon green-icon"><i className="fas fa-lightbulb"></i></div>
                <div>
                  <h4>Kolektivna inteligencija</h4>
                  <p>Pitanja tvojih kolega otvaraju nove perspektive koje ti pomažu u učenju.</p>
                </div>
              </li>
              <li>
                <div className="info-icon green-icon"><i className="fas fa-clipboard-check"></i></div>
                <div>
                  <h4>Praktična Provjera Znanja</h4>
                  <p>Zajedničkim rješavanjem zadataka simuliramo stvarne izazove za test ili ispit.</p>
                </div>
              </li>
            </ul>
          </div>
        </div>
      </section>
    </>
  );
};

export default Instrukcije; 